<script lang="ts" et-landing-template>
    import { defineComponent, onMounted, ref } from 'vue';

    import { useServiceContainer, useStoreContainer } from '~/container';

    import type { EtApiError } from '~/modules/api/et/interfaces';
    import type { Translation } from '~/modules/core/interfaces';

    export default defineComponent({
        template: '#coreEtHappyBirthdayUnsubscribeForm',
        setup() {
            const {
                EtApiHappyBirthdayService,
                QueryStringHelperService,
                ModalService,
                EventsLoggerService,
                EtApiErrorsTranslationService,
            } = useServiceContainer();
            const { ConfigStore } = useStoreContainer();
            const { frontendConfiguration } = ConfigStore;

            const hasApiError = ref(false);
            const apiErrors = ref<Array<Translation>>([]);
            const unsubscribeSuccess = ref(false);
            const loading = ref(false);
            const emailAddress = ref<null | string>(null);

            onMounted(() => {
                emailAddress.value = QueryStringHelperService.query.emailAddress ?? null;

                validate();
            });

            function validate() {
                if (!emailAddress.value) {
                    return showErrorModal();
                }
            }

            function showErrorModal() {
                return ModalService.openErrorModal().then((modalInstance) =>
                    modalInstance.closed.then(() => {
                        window.location.href = frontendConfiguration.routes.base;
                    }),
                );
            }

            function submit() {
                apiErrors.value = [];
                hasApiError.value = false;
                loading.value = true;

                EventsLoggerService.log('happy_birthday_unsubscribe.submit');

                return EtApiHappyBirthdayService.postHappyBirthdayUnsubscribe(emailAddress.value!)
                    .then(() => handleUnsubscribe())
                    .catch((rejection) => handleUnsubscribeRejection(rejection))
                    .finally(() => {
                        loading.value = false;
                    });
            }

            function handleUnsubscribe() {
                unsubscribeSuccess.value = true;
                EventsLoggerService.log('happy_birthday_unsubscribe.success');

                setTimeout(() => {
                    window.location.href = frontendConfiguration.routes.base;
                }, 5000);
            }

            function handleUnsubscribeRejection(rejection: Array<EtApiError>) {
                hasApiError.value = true;
                apiErrors.value = EtApiErrorsTranslationService.translateApiErrors(rejection);

                EventsLoggerService.log('happy_birthday_unsubscribe.error');
            }

            return {
                hasApiError,
                apiErrors,
                unsubscribeSuccess,
                loading,
                submit,
            };
        },
    });
</script>
